import { render, staticRenderFns } from "./ClarityButton.vue?vue&type=template&id=49c2acac&"
import script from "./ClarityButton.vue?vue&type=script&lang=ts&"
export * from "./ClarityButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports